import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

// import utils
import { setBodyBackgroudColor } from 'js/utils/general';

// import containers
import SectionPageWrapper from 'js/containers/section/Section.page-wrapper';
import TransitionPage from 'js/containers/transition/Transition.page';

// import selectors
import { getUserFavoritedCards, getUserRecentlyViewedCards, getAllCards } from 'js/store/cards/Cards.selectors';
import { getSiteMetaData, getTranslationById } from 'js/store/app/App.selectors';

// import components
import GenericMetadata from 'js/components/generic/Generic.metadata';
import GridCardList from 'js/containers/grid/Grid.card-list';
import HeaderFixed from 'js/components/header/Header.fixed';
import LoadingIcon from 'js/components/generic/Generic.loading-icon';

const PAGE_STATES = {
  FAVORITES: {
    selector: getUserFavoritedCards,
    title: 'Favorites',
    localisedId: 'home_page_category_favorites',
    bgColor: '#8FCCF1',
  },
  RECENT: {
    selector: getUserRecentlyViewedCards,
    title: 'Recently Viewed',
    localisedId: 'home_page_category_recent_activity',
    bgColor: '#8FCCF1',
  },
  ALL: {
    selector: getAllCards,
    title: 'All Cards',
    localisedId: 'home_page_category_all_cards',
    bgColor: '#8FCCF1',
  },
};

const PageCards = ({ type, path }) => {
  const { selector, title, localisedId, bgColor } = PAGE_STATES[type] || PAGE_STATES.ALL;
  const cards = useSelector((state) => selector(state, false));
  const siteMetaData = useSelector((state) => getSiteMetaData(state, path));
  const navigate = useNavigate();

  const [cardsSnapshot, setCardsSnapshot] = React.useState(() => cards);

  React.useEffect(() => {
    setBodyBackgroudColor(bgColor);
    if (cards.length > 0 && cardsSnapshot.length === 0) {
      setCardsSnapshot(cards);
    }
  }, [cards]);

  const localisedTitle = useSelector((state) => getTranslationById(state, localisedId, title));

  return (
    <TransitionPage>
      <GenericMetadata
        title={siteMetaData.title}
        description={siteMetaData.description}
        keywords={siteMetaData.keywords}
      />
      <SectionPageWrapper className={'page--favorites'} bgColor={bgColor}>
        <HeaderFixed title={localisedTitle} buttonBackAction={() => navigate(-1)} backgroundColor={bgColor} />
        {/* {cards.length === 0 && <LoadingIcon />} */}
        {cards.length > 0 && <GridCardList cards={cardsSnapshot} />}
      </SectionPageWrapper>
    </TransitionPage>
  );
};

export default PageCards;
